export default "/images/landingbg.svg?3590efc65111ca8febebdc02bcadfe0e";